// extracted by mini-css-extract-plugin
module.exports = {"container":"NewScreenBtn_container__1Nty8","containerIsActive":"NewScreenBtn_containerIsActive__185V7","icon":"NewScreenBtn_icon__37Mud","text":"NewScreenBtn_text__1RyIf"};